import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
// Self-hosted fonts (#238 follow-up) — served from our own origin instead of Google
// Fonts, so no visitor IP leaks to Google and the CSP can drop the external font
// origins. Geist variable (one file for every weight, #1237) + Fraunces variable (optical sizing).
import "@fontsource-variable/geist/wght.css";
import "@fontsource-variable/fraunces/opsz.css";
import "./styles/globals.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
